import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import HeaderRating from "./HeaderRating"
import PlatformsAvailable from "../PlatformsAvailable"
// import MenuGroup from "aldoo-ra/MenuGroup"
import SitePlatform from "../SitePlatform"
import DynamicSVG from "aldoo-ra/DynamicSVG"

const HeaderSectionLeft = () => {
  const { platform } = SitePlatform()

  return (
    <div className="flex flex-col lg:flex-row w-full lg:w-1/2 justify-start items-center">
      {/* Left Section (Texts and button) */}
      <CMSRender
        contentType="PageSectionHeader"
        match={{ "content.name": "HomeHeaderLeft" }}
        renderItem={(data, id) => {
          const button = data.button?.find(
            (item) => item.options?.platform === platform
          ) || data.button?.[0] // Fallback to first button if no platform match
          return (
            <div
              key={id}
              className="flex flex-col w-full lg:w-1/2 lg:min-w-[480px] xl:min-w-[530px] items-center lg:items-start gap-[20px]"
            >
              {/* App Logo */}
              <div>
                <img
                  src={data.image}
                  alt="Oxford Dictionary Logo"
                  className="w-[90px] h-[90px]"
                />
              </div>

              {/* Title */}
              <Typography
                variant="h1"
                className="max-w-[550px] lg:w-full text-center lg:text-left text-text"
              >
                {data.title}
              </Typography>

              {/* CTA Button */}
              {button && (
                <Button variant="primary_xl">
                  <DynamicSVG
                    className="w-8"
                    url={button.image}
                    alt="Platform Logo"
                  />
                  <a href={button.link?.[0]?.url} target="_blank">
                    {button.label}
                  </a>
                </Button>
              )}

              {/* Platforms Available */}
              <PlatformsAvailable
                selectedPlatform={platform}
                variant="centered"
                data={data}
              />

              {/* Product Ratings */}
              <HeaderRating />
            </div>
          )
        }}
      />
    </div>
  )
}

export default HeaderSectionLeft
